// Bootstrap registers its modal Data API listener in the capture phase
// (delegated handlers pass true as addEventListener's capture flag). That
// handler calls Modal.getOrCreateInstance on the target. When the target is
// missing, BaseComponent returns without setting this._config, but the Modal
// constructor still runs and throws while reading this._config.backdrop
// ("undefined is not an object (evaluating 'this._config.backdrop')").
//
// The organization switcher shell used to be appended on turbo:load. That
// event is a later task than a click queued while the deferred bundle
// evaluates, and a Turbo preview never fires it. A fast click in that gap
// reached the Data API with no #main_modal. This module is imported before
// bootstrap so the listener below runs first and inserts the shell. The
// sidenav also renders the shell; this covers a snapshot that doesn't.

const MAIN_MODAL_HTML = `
  <div id="main_modal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title"></h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
        </div>
      </div>
    </div>
  </div>
`

function ensureMainModal() {
  if (document.getElementById('main_modal') || !document.body) return
  document.body.insertAdjacentHTML('beforeend', MAIN_MODAL_HTML)
}

function elementFromEventTarget(target) {
  if (!target) return null
  if (target.nodeType === Node.ELEMENT_NODE) return target
  return target.parentElement
}

// Capture, and registered before bootstrap's own listener. See application.js.
document.addEventListener('click', (event) => {
  const element = elementFromEventTarget(event.target)
  if (!element || !element.closest('[data-bs-target="#main_modal"]')) return
  ensureMainModal()
}, true)

function ensureMainModalWhenSwitcherIsRendered() {
  if (!document.getElementById('switch_organization_link')) return
  ensureMainModal()
}

// Deferred scripts run after the body is parsed but before readystatechange,
// so a click queued during startup is dispatched before turbo:load. Insert
// the shell before this module returns.
ensureMainModalWhenSwitcherIsRendered()
document.addEventListener('turbo:load', ensureMainModalWhenSwitcherIsRendered)
document.addEventListener('turbo:render', ensureMainModalWhenSwitcherIsRendered)
